import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import routes from './routes'

export function createAppRouter() {
  return createRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes,
    scrollBehavior: () => ({ top: 0 }),
  })
}

// 兼容旧的默认导出（guards.ts 等地方可能用到类型）
export default createAppRouter
